<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="medium" (click)="cancel()">Close</ion-button>
    </ion-buttons>
    <ion-title>Pay now</ion-title>
    <!-- <ion-buttons slot="end">
      <ion-button (click)="confirm()" [strong]="true">Confirm</ion-button>
    </ion-buttons> -->
  </ion-toolbar>
</ion-header>
<div *ngIf="errorMessage()" class="ion-padding ion-text-center">
  <ion-icon
    name="alert-circle-outline"
    style="font-size: 48px; color: var(--ion-color-danger)"
  ></ion-icon>
  <p>{{ errorMessage() }}</p>
  <ion-button expand="block" color="medium" (click)="cancel()">Close</ion-button>
</div>
<div
  #stripeElement
  id="stripeElement"
  [hidden]="errorMessage()"
  style="min-height: 420px; overflow: auto"
></div>